module.exports = __webpack_public_path__ + "static/assets/d39c806a09cdcc6d8ffda5515bcf647a.svg";